import React from "react";
import PageWrapper from "../components/layout/PageWrapper";
import CustomerBookingForm from "../containers/bookings/CustomerBookingForm";

const CreateBooking = () => {
  console.log("New booking!");

  return (
    <PageWrapper>
      <CustomerBookingForm />
    </PageWrapper>
  );
};

export default CreateBooking;
